import { LogLevel } from '@azure/msal-browser'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_DIRECTORY_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_MS_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            messageLogger.push(message)
            return
          case LogLevel.Info:
            console.info(message)
            messageLogger.push(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            messageLogger.push(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            messageLogger.push(message)
            return
          default:
            return
        }
      },
    },
  },
}

export let messageLogger = []

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['Files.ReadWrite', 'offline_access', 'User.Read'],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: process.env.REACT_APP_MS_GRAPH_ENDPOINT,
}
